<template>
  <div>
    <EventListComponent v-if="!establishmentsIsLoading" />
    <v-overlay :value="establishmentsIsLoading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { useNamespacedState } from 'vuex-composition-helpers';
import EventListComponent from './EventsList.vue';

export default {
  name: 'EventsListLanding',
  components: { EventListComponent },
  setup() {
    const { establishmentsIsLoading } = useNamespacedState('establishmentsStore', ['establishmentsIsLoading']);

    return {
      establishmentsIsLoading,
    };
  },
};
</script>
